export default __webpack_public_path__ + "static/media/600.45a1c1aa.png";